import { POWER_STRIKE } from '../cards/attack/power-strike';
import { GUARD } from '../cards/defense/guard';
import type { EnemyTemplate } from './template';

/** HEX-83 roster (docs/enemies.md). Common tier: 2×2, 2 dice. Glass cannon — one
 * scaling attack, almost no defence. With 2 dice it can land a 7; ignore it and
 * it stings. Teaches the dice-concentration lever. */
export const SCRAP_GOBLIN: EnemyTemplate = {
  id: 'scrap-goblin',
  name: 'Scrap Goblin',
  glyph: '⚒', // hammer + pick — the scavenger
  tier: 'common',
  hp: 13,
  loadout: [
    { card: POWER_STRIKE, origin: { row: 0, col: 0 }, rotated: false },
    { card: GUARD, origin: { row: 1, col: 0 }, rotated: false },
  ],
  drops: { gold: 3 },
};
